import {
  Component,
  HostListener,
  Inject,
  Input,
  OnInit,
  PLATFORM_ID,
  ViewEncapsulation,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { EnvToken } from '@app/core/env.tokens';
import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { GenericButtonWithArrow } from '@components/shared/genericButtonWithArrow/genericButtonWithArrow';
import { ExternalService } from '@app/services/http/external.service';
import { TranslatePipe } from '@app/pipes/translate.pipe';
import { IconComponent } from '@app/components/ui-icon/icon.component';

@Component({
  imports: [TranslatePipe, GenericButtonWithArrow, IconComponent],
  providers: [ExternalService],
  selector: 'app-why-handyhand',
  encapsulation: ViewEncapsulation.Emulated,
  templateUrl: './whyHandyhandComponent.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./whyHandyhandComponent.scss'],
})
export class WhyHandyhandComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly t = inject(TranslatePipe);
  protected readonly env = inject(EnvToken);
  protected readonly platformId = inject(PLATFORM_ID);
  protected readonly externalService = inject(ExternalService);

  @Input() isPinployeeVerticalPage = false;
  @Input() isLandingPage?: boolean = false;
  @Input() titleLabel?: string;

  phone = `${this.env.cloudFrontImgUrl}/private/lp/phone_create_task.webp`;
  womanWithPhone: string;
  buttonText: string = '';
  currentParams?: string;
  innerWidth: number = 0;

  constructor() {
    const path = String(
      this.t.transform('PAGES.LANDING.USP_HERO_WOMAN_IMG_PATH'),
    ).replace(/^\/+/, '');

    this.womanWithPhone = `${this.env.cloudFrontImgUrl}/${path}`;
  }

  public ngOnInit() {
    this.buttonText = this.t.transform('PAGES.LANDING.BNT_TASK4');
  }

  @HostListener('window:resize')
  onResize() {
    if (isPlatformBrowser(this.platformId)) {
      this.innerWidth = window.innerWidth;
    }
  }

  protected buttonAction() {
    if (this.isPinployeeVerticalPage) {
      return this.openAuthDialog();
    } else {
      return this.externalService.goToCreateTask({
        titleLabel: this.titleLabel,
      });
    }
  }

  protected openAuthDialog() {
    this.currentParams = this.router.url;
    return this.externalService.goToSignup();
  }
}
